import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-order-request',
  templateUrl: './order-request.component.html',
  styleUrls: ['./order-request.component.scss'],
})
export class OrderRequestComponent {

  loader: boolean = false;
  url;
  id;
  resId;
  ChangeInc: boolean = false;
  changeId;
  costValue: boolean = false;
  area;
  Type;
  reasons;
  purrchaseItems: any = [];
  notFixedReasons;
  notFixedCheck: boolean = false;
  notFixedValue;
  reqId;

  constructor(public auth: AuthService, private router: Router, public handler: HandlerService,
    public service: ApiService) { }

  ionViewWillEnter() {
    this.url = window.location.href;
    this.id = this.url.split('/').pop();
    this.getOrder();
    this.getReasons();
    this.getChange();
  }

  getOrder() {
    this.loader = true;
    this.service.getOrderById(this.id).subscribe((res: any) => {
      if (res) {
        this.purrchaseItems = res.serviceRequests;
        this.purrchaseItems.map(dat => {
          if (dat.providerService.billPostVisit == true) {
            Object.assign(dat, { present: true });
          }
        })
        this.loader = false;
      }
    },
      err => {
        this.loader = false;
        this.handler.err(err.error)
      })
  }


  Update(data) {
    this.costValue = true;
  }


  finish() {
    this.loader = true;
    this.service.fixedOrder(this.id, null).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!');
      if (this.url.includes('order-requests')) {
        if (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))
          this.router.navigate(['/vendor-request'])
        else
          this.router.navigate(['/vendor-manage-order']);
      } else if (this.url.includes('manage-requests')) {
        this.router.navigate(['/admin-manage-order']);
      }
      else {
        this.router.navigate(['/requests'])
      }
    })
  }

  getReasons() {
    this.service.reasonsForNotFixed().subscribe((res: any) => {
      this.notFixedReasons = res;
    })
  }

  notFixed(id) {
    this.notFixedCheck = true;
    this.reqId = id;
  }

  clearArray1(value) {
    this.notFixedValue = value.id;
  }

  submit() {
    this.loader = true;
    let post = {
      "id": this.reqId,
      "status": 11,
      "reasonsNotFixed": this.notFixedValue
    }
    this.service.notFixed(this.reqId, post).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!')
      this.notFixedCheck = false;
      this.loader = false;
      this.getOrder();
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }

  Completed(id) {
    this.loader = true;
    let post = {
      "id": id,
      "status": 3,
    }
    this.service.completed(post, id).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!')
      this.loader = false;
      this.getOrder();

    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }

  cancel() {
    if (this.url.includes('order-requests')) {
      if (this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA'))
        this.router.navigate(['/vendor-request'])
      else
        this.router.navigate(['/vendor-manage-order']);
    } else if (this.url.includes('manage-requests')) {
      this.router.navigate(['/admin-manage-order']);
    }
    else {
      this.router.navigate(['/requests'])
    }
  }

  getChange() {
    this.service.getReasons().subscribe(res => {
      this.reasons = res;
    })
  }

  getReason(id) {
    this.resId = id;
    this.ChangeInc = true;
  }
  clearArray(value) {
    this.changeId = value.id;
  }
  clearCapture() {
    this.ChangeInc = false;
    this.updateReason();
  }

  updateReason() {
    this.loader = true;
    let post = {
      "id": this.resId,
      "status": 2,
      "reason": this.changeId
    }
    this.service.updateReasons(post, this.resId).subscribe((res: any) => {
      this.handler.res('Status Updated Successfully !!')
      this.Type = "";
      this.loader = false;
      this.getOrder();

    },
      err => {
        this.loader = false;
        this.handler.err(err)
      })
  }
}
